import React from 'react';
import { combineClassNames } from '../../../app/functions';
import './button_outlined.scss';

const ButtonOutlined = ({ children, className, ...remainingProps }) => (
    <button
        className={combineClassNames(
            'button-outlined',
            className,
        )}
        {...remainingProps}
    >
        {children}
    </button>
);

export default ButtonOutlined;
